module.exports = __webpack_public_path__ + "static/media/logo_v2_white.0d1e7f54.svg";